<template>
  <v-layout>
    <v-tabs vertical class="my-tabs" v-model="active_tab">
      <v-tab class="pl-1 ttext">
        <v-icon left>mdi-table-large</v-icon>តារាង​ ១.២.៣
      </v-tab>
      <v-tab class="pl-1 ttext">
        <v-icon left>mdi-table</v-icon>តារាង​ ៤.៥
      </v-tab>
      <v-tab class="pl-1 ttext">
        <v-icon left>mdi-table</v-icon>តារាង​ ៦.៧.៨.៩​
      </v-tab>
      <v-tab class="pl-1 ttext">
        <v-icon left>mdi-table</v-icon>តារាង​ ១០.១១.១២
      </v-tab>
      <v-tab-item>
        <div class="row">
          <div>
            <healthproblem
              :data="cli.hea_pro"
              :gps="cli.gps"
              :title="title[1]"
              :cur_acc="cur_acc"
            />
          </div>
          <div><firstaid :data="cli.fir_aid" :title="title[2]" /></div>
          <div>
            <schoolClose :data="cli.sch_clo" :title="title[3]" />
          </div>
        </div>
      </v-tab-item>
      <v-tab-item>
        <div>
          <div class="row">
            <div>
              <buildingdemage :data="cli.bui_dem" :title="title[4]" />
            </div>
          </div>
          <div class="row">
            <div>
              <recovery :data="cli.sch_rec" :title="title[5]" />
            </div>
          </div>
        </div>
      </v-tab-item>
      <v-tab-item>
        <div class="row">
          <div>
            <classroom :data="cli.cla_fac" :title="title[6]" />
          </div>
          <div>
            <lwaterelectricity :data="cli.sch_uti" :title="title[7]" />
          </div>
          <div v-if="type_code === 1">
            <prestudentabsent :data="cli.stu_abs" :title="title[8]" />
          </div>
          <div v-else>
            <studentabsent
              :data="cli.stu_abs"
              :type_code="type_code"
              :title="title[8]"
            />
          </div>
        </div>
        <div class="row">
          <div>
            <altEdu :data="cli.alt_edu" :title="title[9]" />
          </div>
        </div>
      </v-tab-item>
      <v-tab-item>
        <div class="row">
          <div v-if="type_code === 1">
            <preMatDem :data="cli.mat_dem" :title="title[10]" />
          </div>
          <div v-else>
            <matDem
              :data="cli.mat_dem"
              :type_code="type_code"
              :title="title[10]"
            />
          </div>
          <div>
            <wastegarden :data="cli.was_gar" :title="title[11]" />
          </div>
          <div>
            <financial :data="cli.sch_fin" :title="title[12]" />

            <div class="my-2 pl-3">
              <v-btn
                class="mx-2"
                v-on:click="verifyClimate"
                :disabled="cli.state === 5"
                btn
                x-large
                color="success"
                dark
                >ត្រួតពិនិត្យទិន្នន័យ</v-btn
              >
              <v-btn
                class="mx-2"
                v-on:click="saveClimate"
                :disabled="cli.state === 5"
                btn
                x-large
                color="success"
                dark
                >រក្សាទុកទិន្នន័យ</v-btn
              >
            </div>
          </div>
        </div>
      </v-tab-item>
    </v-tabs>
  </v-layout>
</template>

<script>
// This will be the school climate change components
import healthProblem from "@/components/ascf/sharedCom/climate/healthProblem.vue";
import firstAid from "@/components/ascf/sharedCom/climate/firstAid.vue";
import schoolClose from "@/components/ascf/sharedCom/climate/schoolClose.vue";
import buildingDemage from "@/components/ascf/sharedCom/climate/buildingDemage.vue";
import recovery from "@/components/ascf/sharedCom/climate/recovery.vue";
import classroom from "@/components/ascf/sharedCom/climate/classroom.vue";
import lWaterElectricity from "@/components/ascf/sharedCom/climate/lWaterElectricity.vue";
import preStudentAbsent from "@/components/ascf/sharedCom/climate/preStudentAbsent.vue";
import studentAbsent from "@/components/ascf/sharedCom/climate/studentAbsent.vue";
import altEdu from "@/components/ascf/sharedCom/climate/alternativeEdu.vue";
import preMatDem from "@/components/ascf/sharedCom/climate/preMaterialDemage.vue";
import matDem from "@/components/ascf/sharedCom/climate/materialDemage.vue";
import wasteGarden from "@/components/ascf/sharedCom/climate/wasteGarden.vue";
import financial from "@/components/ascf/sharedCom/climate/schoolFinancial.vue";

export default {
  props: ["title", "cli", "type_code", "cur_acc"],
  components: {
    buildingdemage: buildingDemage,
    classroom: classroom,
    firstaid: firstAid,
    healthproblem: healthProblem,
    lwaterelectricity: lWaterElectricity,
    recovery: recovery,
    prestudentabsent: preStudentAbsent,
    studentabsent: studentAbsent,
    wastegarden: wasteGarden,
    schoolClose: schoolClose,
    altEdu: altEdu,
    preMatDem: preMatDem,
    matDem: matDem,
    financial: financial,
  },
  data() {
    return {
      active_tab: 0,
    };
  },
  methods: {
    saveClimate: function () {
      this.$store.dispatch("climate/saveClimate");
    },
    verifyClimate: function () {
      this.$store.dispatch("climate/verifyClimate");
    },
  },
};
</script>
<style scoped>
.row {
  display: flex;
}
.ttext {
  font-family: "Siemreap";
  font-size: 12px;
  font-weight: bold;
}
div.my-tabs [role="tab"] {
  justify-content: flex-start;
}
</style>